import { render } from "./ElementRender.vue?vue&type=template&id=57b6c0fe"
import script from "./ElementRender.vue?vue&type=script&lang=js"
export * from "./ElementRender.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__